import Choices from 'choices.js'

const selects = document.querySelector('select.choices')
if (selects) {
  // Standard hates this
  const choices = new Choices('select.choices', {shouldSort: false, shouldSortItems: false}) // eslint-disable-line
}
